export default __webpack_public_path__ + "static/media/Hero's Jerkin.21d2d5ec.jpg";